export function getSongMeta(song) {
  if (song.meta) {
    return song.meta;
  }

  return { category: '', artist: '', title: song.fileName || song.title };
}
